const r = (t, ...a) => String.raw({ raw: t }, ...a);
export {
  r as default
};
